import { render, staticRenderFns } from "./userMsgIs.vue?vue&type=template&id=22fdcb56&scoped=true&"
import script from "./userMsgIs.vue?vue&type=script&lang=js&"
export * from "./userMsgIs.vue?vue&type=script&lang=js&"
import style0 from "./userMsgIs.vue?vue&type=style&index=0&id=22fdcb56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdcb56",
  null
  
)

export default component.exports